export function strToSnakeCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]{2,})/g, (match) => match.toLowerCase())
    .toLowerCase()
}

export function strToCamelCase(str) {
  return str.replace(/^[A-Z]/, (match) => match.toLowerCase()).replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase())
}

export function strToPascalCase(str) {
  return str.toLowerCase().replace(/(?:^|\s|_|-)+(.)/g, (match, chr) => chr.toUpperCase())
}

export function strToSpacedWords(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2")
}

export function strToUpperSnakeCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/\s+/g, "_")
    .replace(/[^\w_]/g, "")
    .toUpperCase()
}

export function validatePassword(password) {
  const minLength = 6
  const regex = new RegExp(`^(?=.*[A-Za-z])(?=.*\\d).{${minLength},}$`)
  return regex.test(password)
}
